<template>
  <div>
    <o-field-group
      v-slot="{ status }"
      :rules="item.required ? 'required' : ''"
      class="w-full"
      :label="item.label"
      :info="item.description || ''"
    >
      <toggle-field
        v-if="item.type === 'boolean'"
        v-model="_value"
        :value="1"
        :unchecked-value="0"
        :label="item.label"
        :status="status"
      />

      <text-area-field
        v-if="item.type === 'text'"
        v-model="_value"
        :label="item.label"
        :status="status"
        :placeholder="item.default || ''"
        rows="10"
      />

      <HTMLEditor
        v-if="item.type === 'html'"
        v-model="_value"
        :label="item.label"
        :status="status"
        class="border rounded-lg dark:border-gray-800 h-48"
        :placeholders="contentTemplate.placeholders.text"
      />
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import {
  TextAreaField,
  ToggleField,
} from '@/components/fields'

import HTMLEditor from '~/components/elements/editor/HTMLEditor.vue'

interface Props {
  modelValue: string | boolean | number
  item: Record<string, any>
  contentTemplate?: Record<string, any>
}

const props = withDefaults(defineProps<Props>(), {
  contentTemplate: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  },
})

onMounted(() => {
  if (_value.value === undefined || _value.value === null) {
    _value.value = props.item.default
  }
})
</script>
